<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表附列资料(一)<br />(本期销售情况明细表)</dt>

      <dd>
        <div>
          纳税人名称（公章）：{{ staticConfig.companyName }}（一般纳税人）<br />
          纳税人识别号（统一社会信用代码）：<br />
          {{ staticConfig.creditCode }}
        </div>

        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table style="line-height: 20px">
        <thead>
          <tr>
            <td rowspan="3" colspan="4" class="td_align">项目及栏次</td>
            <td colspan="2" name="R0TD1" id="R0TD1" class="td_align ts">开具税控增值税专用发票</td>
            <td colspan="2" name="R0TD2" id="R0TD2" class="td_align ts">开具其他发票</td>
            <td colspan="2" name="R0TD3" id="R0TD3" class="td_align ts">未开具发票</td>
            <td colspan="2" name="R0TD4" id="R0TD4" class="td_align ts">纳税检查调整</td>
            <td colspan="3" class="td_align td_height">合计</td>
            <td rowspan="2" name="R0TD5" id="R0TD5" class="td_align ts" style="width: 100px">服务、不动产和无形资产扣除项目 本期实际扣除金额</td>
            <td colspan="2" class="td_align">扣除后</td>
          </tr>
          <tr>
            <td class="td_align td_height" style="width: 120px">销售额</td>
            <td class="td_align" style="width: 120px">销项(应纳)税额</td>
            <td class="td_align" style="width: 120px">销售额</td>
            <td class="td_align" style="width: 120px">销项(应纳)税额</td>
            <td class="td_align" style="width: 120px">销售额</td>
            <td class="td_align" style="width: 120px">销项(应纳)税额</td>
            <td class="td_align" style="width: 120px">销售额</td>
            <td class="td_align" style="width: 120px">销项(应纳)税额</td>
            <td class="td_align" style="width: 120px">销售额</td>
            <td class="td_align" style="width: 120px">销项(应纳)税额</td>
            <td class="td_align" style="width: 120px">价税合计</td>
            <td class="td_align" style="width: 120px">含税(免税)销售额</td>
            <td class="td_align" style="min-width: 100px">销项(应纳)税额</td>
          </tr>
          <tr>
            <td class="td_align td_height">1</td>
            <td class="td_align">2</td>
            <td class="td_align">3</td>
            <td class="td_align">4</td>
            <td class="td_align">5</td>
            <td class="td_align">6</td>
            <td class="td_align">7</td>
            <td class="td_align">8</td>
            <td class="td_align">9=1+3+5+7</td>
            <td class="td_align">10=2+4+6+8</td>
            <td class="td_align">11=9+10</td>
            <td class="td_align">12</td>
            <td class="td_align">13=11-12</td>
            <td class="td_align">14=13÷(100%+税率或征收率)×税率或征收率</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="7" style="width: 50px">一、<br />一般<br />计税<br />方法<br />计税</td>
            <td rowspan="5" style="width: 100px">全部项目</td>
            <td name="R1TD0" id="R1TD0" style="width: 150px">13%税率的货物及加工修理修配劳务</td>
            <td style="width: 30px">1</td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v1x2.value) }}
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v1x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v1x4.value) }}
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v1x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v1x6.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v1x8.value) }}
            </td>
            <td>{{ parseFloatNum(data.v1x9.value) }}</td>
            <td>{{ parseFloatNum(data.v1x10.value) }}</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td name="R2TD0" id="R2TD0">13%税率的服务、不动产和无形资产</td>
            <td>2</td>
            <td>
              <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v2x2.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v2x4.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v2x6.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v2x8.value) }}
            </td>
            <td>{{ parseFloatNum(data.v2x9.value) }}</td>
            <td class="TD10H">{{ parseFloatNum(data.v2x10.value) }}</td>
            <td>{{ parseFloatNum(data.v2x11.value) }}</td>
            <td class="TD12H">
              <el-input-number v-model.trim="data.v2x12.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x13.value) }}</td>
            <td class="TD14H">{{ parseFloatNum(data.v2x14.value) }}</td>
          </tr>
          <tr>
            <td name="R2TD0" id="R2TD0">9%税率的货物及加工修理修配劳务</td>
            <td>3</td>
            <td>
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v3x2.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v3x4.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v3x6.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v3x8.value) }}
            </td>
            <td>{{ parseFloatNum(data.v3x9.value) }}</td>
            <td class="TD10H">{{ parseFloatNum(data.v3x10.value) }}</td>
            <td>{{ parseFloatNum(data.v3x11.value) }}</td>
            <td class="TD12H">
              <el-input-number v-model.trim="data.v3x12.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x13.value) }}</td>
            <td class="TD14H">{{ parseFloatNum(data.v3x14.value) }}</td>
          </tr>
          <tr>
            <td name="R4TD0" id="R4TD0">9%税率的服务、不动产和无形资产</td>
            <td>4</td>
            <td>
              <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v4x2.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v4x4.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v4x6.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v4x8.value) }}
            </td>
            <td>{{ parseFloatNum(data.v4x9.value) }}</td>
            <td class="TD10H">{{ parseFloatNum(data.v4x10.value) }}</td>
            <td>{{ parseFloatNum(data.v4x11.value) }}</td>
            <td class="TD12H">
              <el-input-number v-model.trim="data.v4x12.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x13.value) }}</td>
            <td class="TD14H">{{ parseFloatNum(data.v4x14.value) }}</td>
          </tr>
          <tr>
            <td name="R5TD0" id="R5TD0">6%税率</td>
            <td>5</td>
            <td>
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v5x2.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v5x4.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v5x6.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v5x8.value) }}
            </td>
            <td>{{ parseFloatNum(data.v5x9.value) }}</td>
            <td class="TD10H">{{ parseFloatNum(data.v5x10.value) }}</td>
            <td>{{ parseFloatNum(data.v5x11.value) }}</td>
            <td class="TD12H">
              <el-input-number v-model.trim="data.v5x12.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x13.value) }}</td>
            <td class="TD14H">{{ parseFloatNum(data.v5x14.value) }}</td>
          </tr>
          <tr>
            <td rowspan="2">其中：即征即退项目</td>
            <td name="R6TD0" id="R6TD0">即征即退货物及加工修理修配劳务</td>
            <td>6</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value1" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value2" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td name="R7TD0" id="R7TD0">即征即退服务、不动产和无形资产</td>
            <td>7</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value3" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td class="TD10H">
              <el-input-number v-model.trim="defaultValueData.value4" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD12H">
              <el-input-number v-model.trim="defaultValueData.value5" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD14H">0.00</td>
          </tr>
          <tr>
            <td rowspan="11">二、<br />简易<br />计税<br />方法<br />计税</td>
            <td rowspan="9">全部征税项目</td>
            <td>6%征收率</td>
            <td>8</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value6" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value7" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value8" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value9" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value10" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value11" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td>0.00</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td name="R9aTD0" id="R9aTD0">5%征收率的货物及加工修理修配劳务</td>
            <td>9a</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value12" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value13" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value14" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value15" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value16" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value17" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td>0.00</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td name="R10TD0" id="R10TD0">5%征收率的服务、不动产和无形资产</td>
            <td>9b</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value18" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value19" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value20" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value21" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value22" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value23" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value24" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value25" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD10H">0.00</td>
            <td>0.00</td>
            <td class="TD12H">
              <el-input-number v-model.trim="defaultValueData.value26" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD14H">0.00</td>
          </tr>
          <tr>
            <td>4%征收率</td>
            <td>10</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value27" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value28" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value29" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value30" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value31" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value32" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td>0.00</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td name="R11TD0" id="R11TD0">3%征收率的货物及加工修理修配劳务</td>
            <td>11</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value33" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value34" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value35" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value36" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value37" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value38" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td>0.00</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td name="R12TD0" id="R12TD0">3%征收率的服务、不动产和无形资产</td>
            <td>12</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value39" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value40" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value41" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value42" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value43" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value44" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td class="TD10H">0.00</td>
            <td>0.00</td>
            <td class="TD12H">
              <el-input-number v-model.trim="defaultValueData.value45" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD14H">0.00</td>
          </tr>
          <tr>
            <td id="R13TD2">预征率&nbsp;&nbsp;&nbsp;%</td>
            <td>13a</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value46" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value47" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value48" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value49" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value50" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value51" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value52" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value53" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD10H">0.00</td>
            <td>0.00</td>
            <td class="TD12H">
              <el-input-number v-model.trim="defaultValueData.value54" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td>0.00</td>
          </tr>
          <tr>
            <td id="R14TD1">预征率&nbsp;&nbsp;&nbsp;%</td>
            <td>13b</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value55" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value56" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value57" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value58" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value59" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value60" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value61" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value62" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD10H">0.00</td>
            <td>0.00</td>
            <td class="TD12H">
              <el-input-number v-model.trim="defaultValueData.value63" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td>0.00</td>
          </tr>
          <tr>
            <td id="R14TD2">预征率&nbsp;&nbsp;&nbsp;%</td>
            <td>13c</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value64" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value65" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value66" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value67" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value68" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value69" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td class="TD10H">0.00</td>
            <td>0.00</td>
            <td class="TD12H">
              <el-input-number v-model.trim="defaultValueData.value70" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD14H">0.00</td>
          </tr>
          <tr>
            <td rowspan="2">其中：即征即退项目</td>
            <td>即征即退货物及加工修理修配劳务</td>
            <td>14</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value71" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value72" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---<input type="hidden" id="R17TD15" value="29" class="ipt" /></td>
          </tr>
          <tr>
            <td>即征即退服务、不动产和无形资产</td>
            <td>15</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value73" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value74" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD12H">
              <el-input-number v-model.trim="defaultValueData.value75" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td class="TD14H">0.00</td>
          </tr>
          <tr>
            <td rowspan="2">三、<br />免抵<br />退税</td>
            <td colspan="2">货物及加工修理修配劳务</td>
            <td>16</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value76" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value77" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="2">服务、不动产和无形资产</td>
            <td>17</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value78" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value79" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td>---</td>
            <td>0.00</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value80" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td>---</td>
          </tr>
          <tr>
            <td rowspan="2">四、<br />免税</td>
            <td colspan="2">货物及加工修理修配劳务</td>
            <td>18</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value81" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value82" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value83" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value84" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td colspan="2">服务、不动产和无形资产</td>
            <td>19</td>
            <td>---</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value85" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value86" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
            <td>---</td>
            <td>0.00</td>
            <td>---</td>
            <td>0.00</td>
            <td>
              <el-input-number v-model.trim="defaultValueData.value87" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>0.00</td>
            <td>---</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding: 5px 0">
      <span style="font-size: 20px; color: red; margin-right: 5px; font-family: monospace">★</span>
      <span>温馨提示：销售额不包括销项税额（或应纳税额），纳税人采用销售额和销项税额合并定价方法的，按照下列公式计算销售额：销售额＝含税销售额÷（1+税率或征收率）</span>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 5行第2列第4列计算
        for (let row = 1; row <= 5; row++) {
          // 第1,2行税率13%
          // 第3,4行税率9%
          // 第5行税率6%
          let rate;
          if ([1, 2].includes(row)) {
            rate = 0.13;
          }
          if ([3, 4].includes(row)) {
            rate = 0.09;
          }
          if ([5].includes(row)) {
            rate = 0.06;
          }

          // 2,4,6,8列等于1,3,5,7乘以税率
          for (let column = 2; column <= 8; column += 2) {
            data.value[`v${row}x${column}`].value = new Big(data.value[`v${row}x${column - 1}`].value).times(rate).round(2).toNumber();
          }
          // 9=1+3+5+7
          data.value[`v${row}x9`].value = new Big(data.value[`v${row}x1`].value)
            .plus(data.value[`v${row}x3`].value)
            .plus(data.value[`v${row}x5`].value)
            .plus(data.value[`v${row}x7`].value)
            .round(2)
            .toNumber();
          // 10=2+4+6+8
          data.value[`v${row}x10`].value = new Big(data.value[`v${row}x2`].value)
            .plus(data.value[`v${row}x4`].value)
            .plus(data.value[`v${row}x6`].value)
            .plus(data.value[`v${row}x8`].value)
            .round(2)
            .toNumber();
          // 11=9+10
          data.value[`v${row}x11`].value = new Big(data.value[`v${row}x9`].value).plus(data.value[`v${row}x10`].value).round(2).toNumber();
          // 13=11-12
          data.value[`v${row}x13`].value = new Big(data.value[`v${row}x11`].value).minus(data.value[`v${row}x12`].value).round(2).toNumber();
          // 14=13÷(100%+税率或征收率)×税率或征收率
          let rate2 = new Big(rate).plus(1);
          data.value[`v${row}x14`].value = new Big(data.value[`v${row}x13`].value).div(rate2).times(rate).round(2).toNumber();
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 2000px !important;
}
</style>

<script>
const tableHtml = `
<table style="line-height: 20px;">
  <thead>
    <tr>
      <td rowspan="3" colspan="4" class="td_align">项目及栏次</td>
      <td colspan="2" name="R0TD1" id="R0TD1" class="td_align ts">开具税控增值税专用发票</td>
      <td colspan="2" name="R0TD2" id="R0TD2" class="td_align ts">开具其他发票</td>
      <td colspan="2" name="R0TD3" id="R0TD3" class="td_align ts">未开具发票</td>
      <td colspan="2" name="R0TD4" id="R0TD4" class="td_align ts">纳税检查调整</td>
      <td colspan="3" class="td_align td_height">合计</td>
      <td rowspan="2" name="R0TD5" id="R0TD5" class="td_align ts" style="width: 100px;">
        服务、不动产和无形资产扣除项目 本期实际扣除金额
      </td>
      <td colspan="2" class="td_align">扣除后</td>
    </tr>
    <tr>
      <td class="td_align td_height" style="width: 120px;">销售额</td>
      <td class="td_align" style="width: 120px;">销项(应纳)税额</td>
      <td class="td_align" style="width: 120px;">销售额</td>
      <td class="td_align" style="width: 120px;">销项(应纳)税额</td>
      <td class="td_align" style="width: 120px;">销售额</td>
      <td class="td_align" style="width: 120px;">销项(应纳)税额</td>
      <td class="td_align" style="width: 120px;">销售额</td>
      <td class="td_align" style="width: 120px;">销项(应纳)税额</td>
      <td class="td_align" style="width: 120px;">销售额</td>
      <td class="td_align" style="width: 120px;">销项(应纳)税额</td>
      <td class="td_align" style="width: 120px;">价税合计</td>
      <td class="td_align" style="width: 120px;">含税(免税)销售额</td>
      <td class="td_align" style="min-width: 100px;">销项(应纳)税额</td>
    </tr>
    <tr>
      <td class="td_align td_height">1</td>
      <td class="td_align">2</td>
      <td class="td_align">3</td>
      <td class="td_align">4</td>
      <td class="td_align">5</td>
      <td class="td_align">6</td>
      <td class="td_align">7</td>
      <td class="td_align">8</td>
      <td class="td_align">9=1+3+5+7</td>
      <td class="td_align">10=2+4+6+8</td>
      <td class="td_align">11=9+10</td>
      <td class="td_align">12</td>
      <td class="td_align">13=11-12</td>
      <td class="td_align">14=13÷(100%+税率或征收率)×税率或征收率</td>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td rowspan="7" style="width: 50px;">
        <div class="td_align">一、<br>一般<br>计税<br>方法<br>计税</div>
      </td>
      <td rowspan="5" style="width: 100px;">
        <div class="td_height td_align">全部项目</div>
      </td>
      <td name="R1TD0" id="R1TD0" style="width: 150px;">13%税率的货物及加工修理修配劳务</td>
      <td style="width: 30px;">
        <div class="td_height td_align">1</div>
      </td>
      <td>
        <div validate="data_1_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td name="R2TD0" id="R2TD0">13%税率的服务、不动产和无形资产</td>
      <td>
        <div class="td_height td_align">2</div>
      </td>
      <td>
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_2_12" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td name="R2TD0" id="R2TD0">9%税率的货物及加工修理修配劳务</td>
      <td>
        <div class="td_height td_align">3</div>
      </td>
      <td>
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_3_12" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td name="R4TD0" id="R4TD0">9%税率的服务、不动产和无形资产</td>
      <td>
        <div class="td_height td_align">4</div>
      </td>
      <td>
        <div validate="data_4_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_4_12" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td name="R5TD0" id="R5TD0">6%税率</td>
      <td>
        <div class="td_height td_align">5</div>
      </td>
      <td>
        <div validate="data_5_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_5_12" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td rowspan="2">
        <div class="td_align">其中：即征即退项目</div>
      </td>
      <td name="R6TD0" id="R6TD0">即征即退货物及加工修理修配劳务</td>
      <td>
        <div class="td_height td_align">6</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_6_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_6_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td name="R7TD0" id="R7TD0">即征即退服务、不动产和无形资产</td>
      <td>
        <div class="td_height td_align">7</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_7_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="TD10H">
        <div validate="data_7_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_7_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td rowspan="11">
        <div class="td_align">二、<br>简易<br>计税<br>方法<br>计税</div>
      </td>
      <td rowspan="9">全部征税项目</td>
      <td>6%征收率</td>
      <td>
        <div class="td_height td_align">8</div>
      </td>
      <td>
        <div validate="data_8_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_8_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_8_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_8_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_8_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_8_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td name="R9aTD0" id="R9aTD0">5%征收率的货物及加工修理修配劳务</td>
      <td>
        <div class="td_height td_align">9a</div>
      </td>
      <td>
        <div validate="data_9_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_9_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_9_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_9_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_9_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_9_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td name="R10TD0" id="R10TD0">5%征收率的服务、不动产和无形资产</td>
      <td>
        <div class="td_height td_align">9b</div>
      </td>
      <td>
        <div validate="data_10_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_10_12" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td>4%征收率</td>
      <td>
        <div class="td_height td_align">10</div>
      </td>
      <td>
        <div validate="data_11_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td name="R11TD0" id="R11TD0">3%征收率的货物及加工修理修配劳务</td>
      <td>
        <div class="td_height td_align">11</div>
      </td>
      <td>
        <div validate="data_12_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_12_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_12_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_12_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_12_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_12_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td name="R12TD0" id="R12TD0">3%征收率的服务、不动产和无形资产</td>
      <td>
        <div class="td_height td_align">12</div>
      </td>
      <td>
        <div validate="data_13_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_13_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_13_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_13_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_13_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_13_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_13_10" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td id="R13TD2">预征率&nbsp;&nbsp;&nbsp;%</td>
      <td>
        <div class="td_height td_align">13a</div>
      </td>
      <td>
        <div validate="data_14_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_14_12" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td id="R14TD1">预征率&nbsp;&nbsp;&nbsp;%</td>
      <td>
        <div class="td_height td_align">13b</div>
      </td>
      <td>
        <div validate="data_15_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_15_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_15_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_15_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_15_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_15_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_15_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_15_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_15_12" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td id="R14TD2">预征率&nbsp;&nbsp;&nbsp;%</td>
      <td>
        <div class="td_height td_align">13c</div>
      </td>
      <td>
        <div validate="data_16_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_16_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_16_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_16_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_16_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_16_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD10H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_16_10" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td rowspan="2">其中：即征即退项目</td>
      <td>即征即退货物及加工修理修配劳务</td>
      <td>
        <div class="td_height td_align">14</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_17_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_17_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---<input type="hidden" id="R17TD15" value="29" class="ipt"></div>
      </td>
    </tr>
    <tr>
      <td>即征即退服务、不动产和无形资产</td>
      <td>
        <div class="td_height td_align">15</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_18_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_18_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD12H">
        <div validate="data_18_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td class="TD14H">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td rowspan="2">
        <div class="td_align">三、<br>免抵<br>退税</div>
      </td>
      <td colspan="2">货物及加工修理修配劳务</td>
      <td>
        <div class="td_height td_align">16</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_19_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_19_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td colspan="2">服务、不动产和无形资产</td>
      <td>
        <div class="td_height td_align">17</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_20_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_20_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_20_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td rowspan="2">
        <div class="td_align">四、<br>免税</div>
      </td>
      <td colspan="2">货物及加工修理修配劳务</td>
      <td>
        <div class="td_height td_align">18</div>
      </td>
      <td>
        <div validate="data_21_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_21_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_21_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_21_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
    <tr>
      <td colspan="2">服务、不动产和无形资产</td>
      <td>
        <div class="td_height td_align">19</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_22_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div validate="data_22_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_22_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-nocontent">---</div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
const defaultValueData = ref(
  Object.fromEntries(
    Array(90)
      .fill(null)
      .map((item, index) => {
        return [`value${index + 1}`, 0];
      })
  )
);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
